<template id="modal-template">
    <transition name="modal" appear v-if="modal">
        <div class="modal-container">
            <div class="modal-wrapper">
                <div class="modal modal--flat modal--4">
                    <div class="modal__head">
                        <button class="modal__close" type="button" @click="modal = false">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 15.6 15.6" style="enable-background:new 0 0 15.6 15.6;" xml:space="preserve">
                                <g style="fill:#ffffff">
                                    <path d="M0,1.4L1.4,0l14.1,14.1l-1.4,1.4L0,1.4z" />
                                    <path d="M14.1,0l1.4,1.4L1.4,15.6L0,14.1L14.1,0z" />
                                </g>
                            </svg>
                        </button>
                        <h1 class="modal__title">공유하기</h1>
                    </div>
                    <div class="modal__foot modal__foot-no-border">
                        <ul class="modal__buttons modal__buttons--narrow">
                            <li><kakao class="link-button" :kakaoData="kakaoData" /></li>
                            <li><facebook class="link-button" /></li>
                            <li><url class="link-button" /></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Url from "./url.vue";
import Kakao from "./kakao.vue";
import Facebook from "./facebook.vue";
export default {
    components: {
        Url,
        Kakao,
        Facebook,
    },
    props: {
        kakaoData: Object,
    },
    data() {
        return {
            modal: false,
        };
    },
    computed: {},
};
</script>

<style lang="scss" scoped>
/* 트랜지션 전용 스타일 */
// .v-leave-active {
//   position: absolute;
// }
// .v-enter {
//   transform: translateX(-100%);
// }
// .v-leave-to {
//   transform: translateX(100%);
// }

/* 모달 스타일 */
.modal__buttons {
    list-style: none;
    > li {
        padding: 0 1em;
    }
}

.link-button {
    display: flex;
    flex-direction: column;
    align-items: center;

    text-align: center;
}
</style>
